export const stripNonNumeric = (original: any) => {
    const value = original;
    if (typeof value !== 'string' && typeof value !== 'number') {
        return NaN;
    }
    if (typeof value === 'number') {
        return value;
    }
    return parseFloat(value.replace(/[^0-9.]+/g, ''));
};

export const extractNumber = (original: any, fallback = 0) => {
    const value = original;
    if (typeof value === 'string') {
        const parsedValue = stripNonNumeric(value);
        return Number.isNaN(parsedValue) ? fallback : parsedValue;
    }
    return value;
};

export const formatMonthDayYear = (original: any) => {
    if (!original || typeof original !== 'string') {
        return null;
    }
    const value = original;
    if (!value) {
        /* eslint-disable no-console */
        console.warn('No value passed to inputFormatters.formatMonthDayYear.');
        /* eslint-enable no-console */

        return null;
    }
    const num = value.replace(/\D/g, '');
    const match = num.match(/(\d{2})(\d{1,2})?(\d*)/);
    // Restrict field to a maximum character count
    if (match && match[0].length > 8) {
        return value.substring(0, value.length - 1);
    }

    if (!match || !match[2]) {
        if (num === '') {
            return null;
        }
        return num;
    }

    if (!match[3]) {
        return `${match[1]}/${match[2]}`;
    }

    return `${match[1]}/${match[2]}/${match[3]}`;
};

export const formatPhoneNumber = (original: any) => {
    if (!original || typeof original !== 'string') {
        return null;
    }
    let value = original;
    const MAX_CHARS = 14;
    const maxLength = value.length < MAX_CHARS ? value.length : MAX_CHARS;

    if (value.length > MAX_CHARS) {
        value = value.substring(0, maxLength);
    }

    const num = value.replace(/\D/g, '');
    const match = num.match(/(\d{3})(\d{1,3})?(\d*)/);

    if (!match || !match[2]) {
        return num;
    }

    if (!match[3]) {
        return `(${match[1]}) ${match[2]}`;
    }

    return `(${match[1]}) ${match[2]}-${match[3]}`;
};
